import { moleculeHeadingFields } from 'molecules/Heading/config';
import imageField from 'molecules/Image/config';
import sectionFields from 'molecules/Section/config';

import type { Component, Input } from '@builder.io/sdk';

const featuredSessionsFields = [
  {
    name: 'heading',
    type: 'object',
    subFields: moleculeHeadingFields,
    helperText: 'Heading block shown above the cards (e.g. "Featured Sessions").',
  },
  {
    ...imageField('backgroundImage'),
    helperText: 'Full-width background image (desktop). Use a pre-treated/darkened image; no overlay is applied.',
  },
  {
    ...imageField('backgroundImageMobile'),
    helperText: 'Optional background image for small screens (≤640px). Falls back to the desktop image if empty.',
  },
  {
    name: 'sessions',
    type: 'list',
    helperText: 'Add the featured session cards. Each card shows a title and a short description.',
    subFields: [
      { name: 'id', type: 'string', required: true, showIf: 'false' },
      {
        name: 'title',
        type: 'string',
        required: true,
        defaultValue: 'Session title',
        helperText: 'Card title (required).',
      },
      {
        name: 'body',
        type: 'longText',
        helperText: 'Short description shown below the title.',
      },
    ],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange: (options: Map<string, any>) => {
      options.get('sessions').forEach((item: Map<string, string>, index: number) => {
        item.set('id', `session-${index}`);
      });
    },
  },
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const featuredSessionsConfig = {
  name: 'FeaturedSessions',
  inputs: featuredSessionsFields,
} satisfies Component;

export type FeaturedSessionsConfigProps = GenerateBuilder<typeof featuredSessionsFields>;

export default featuredSessionsConfig;
